import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { API } from "@/lib/api";
import DataTable, { downloadBlob } from "@/components/DataTable";
import CommercialStatusBadge from "@/components/CommercialStatusBadge";

export default function PoList() {
  const nav = useNavigate();
  const [customers, setCustomers] = useState([]);

  useEffect(() => { api.get("/customers").then((r) => setCustomers(r.data)); }, []);

  const fetchData = React.useCallback(async ({ skip, limit, sort, search, filters }) => {
    const params = { skip, limit, sort, search };
    if (filters.status) params.status = filters.status;
    if (filters.customer_id) params.customer_id = filters.customer_id;
    const { data } = await api.get("/purchase-orders-list", { params });
    return data;
  }, []);

  async function handleExport() {
    const token = localStorage.getItem("hispl_token");
    const res = await fetch(`${API}/purchase-orders-list/export`, { headers: { Authorization: `Bearer ${token}` } });
    await downloadBlob(res, "purchase_orders.xlsx");
  }

  const columns = [
    { key: "po_number", label: "PO #", sortable: true,
      render: (r) => <span className="font-mono text-[12px] font-semibold text-blue-900">{r.po_number}</span> },
    { key: "po_date", label: "Date", sortable: true, className: "font-mono text-xs text-slate-600" },
    { key: "customer_name", label: "Customer", className: "text-slate-800" },
    { key: "plant_name", label: "Plant", visibleByDefault: false, className: "text-slate-600 text-xs" },
    { key: "quotation_number", label: "Quotation #", visibleByDefault: false,
      render: (r) => <span className="font-mono text-xs text-slate-600">{r.quotation_number}</span> },
    { key: "line_count", label: "Lines",
      render: (r) => <span className="font-mono text-xs">{r.line_count}</span> },
    { key: "total_qty", label: "Total Qty", visibleByDefault: false,
      render: (r) => <span className="font-mono text-xs font-semibold">{r.total_qty}</span> },
    { key: "order_value", label: "Order Value ₹",
      render: (r) => <span className="font-mono text-xs font-semibold">₹{(r.order_value || 0).toLocaleString("en-IN")}</span> },
    { key: "status", label: "Status", sortable: true,
      render: (r) => <CommercialStatusBadge status={r.status} /> },
  ];

  return (
    <div data-testid="po-list-page" className="space-y-4">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-red-600 font-semibold">Commercial Workflow · Stage 3</div>
        <h1 className="text-3xl font-bold text-slate-900 mt-1" style={{ fontFamily: "Chivo, sans-serif" }}>Customer POs</h1>
        <p className="text-sm text-slate-500 mt-1">Customer purchase orders received against approved quotations. HISPL records these — it never generates PO numbers.</p>
      </div>

      <DataTable
        columns={columns} fetchData={fetchData} onExport={handleExport}
        filters={[
          { key: "status", label: "Status",
            options: ["Received", "Accepted", "Cancelled", "Closed"].map((s) => ({ value: s, label: s })) },
          { key: "customer_id", label: "Customer",
            options: customers.map((c) => ({ value: c.id, label: c.name })) },
        ]}
        storageKey="pos"
        onRowClick={(r) => nav(`/purchase-orders/${r.id}`)}
        emptyMessage="No customer POs yet. Record one from an approved quotation."
      />
    </div>
  );
}
